module.exports = __webpack_public_path__ + "static/img/boron-1.fc9de82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/boron-1.jpg
// module id = rAj8
// module chunks = 1